// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__28xlN","left":"StickyBox_left__3aLdh","right":"StickyBox_right__lqGBS"};